import { types } from '../types/types';

const initialState = {
	biases: [],
	currentBias: null,
	updateSubbiasesFlag: false,
};

export const biasReducer = (state = initialState, action) => {
	switch (action.type) {
		case types.setBiases:
			return {
				...state,
				biases: action.payload,
			};

		case types.addBias:
			return {
				...state,
				biases: [...state.biases, ...action.payload],
			};

		case types.currentBias:
			return {
				...state,
				currentBias: action.payload,
			};

		case types.setBias:
			return action.payload;

		case types.cleanBias:
			return initialState;

		case types.updateSubbiasesFlag:
			return {
				...state,
				updateSubbiasesFlag: action.payload,
			};

		default:
			return state;
	}
};
